export class ExpressionDefinitionApiV2 {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEligibilityCriteriaExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/eligibility-schema');
  }

  async getLlpaCapSchemaExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/llpa-cap-schema');
  }

  async getAdjustmentSchemaExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/adjustment-schema');
  }

  async getMarginSchemaExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/margin-schema');
  }

  async getMiCoverageExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/mi-coverage-percentage-schema');
  }

  async getEscrowRequirementsExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/escrow-requirements-schema');
  }

  async getMiRulesExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/mi-rule-schema');
  }

  async getRateLockTermsExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/rate-lock-term-criteria-schema');
  }

  async getFeeTypeExpressionDefinition() {
    return this.#http.get('/api/expression-definitions/fee-types');
  }
}
